 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		48: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"3":"component---src-pages-404-js","4":"component---src-pages-about-index-de-js","5":"component---src-pages-about-index-en-js","6":"component---src-pages-career-frontend-dev-role-index-de-js","7":"component---src-pages-career-frontend-dev-role-index-en-js","8":"component---src-pages-career-index-de-js","9":"component---src-pages-career-index-en-js","10":"component---src-pages-consulting-index-de-js","11":"component---src-pages-consulting-index-en-js","12":"component---src-pages-contact-de-js","13":"component---src-pages-contact-en-js","14":"component---src-pages-data-privacy-de-js","15":"component---src-pages-data-privacy-en-js","16":"component---src-pages-imprint-de-js","17":"component---src-pages-imprint-en-js","18":"component---src-pages-index-de-js","19":"component---src-pages-index-js","20":"component---src-pages-partnership-certified-partner-index-de-js","21":"component---src-pages-partnership-certified-partner-index-en-js","22":"component---src-pages-partnership-index-de-js","23":"component---src-pages-partnership-index-en-js","24":"component---src-pages-products-assemblycontrol-index-de-js","25":"component---src-pages-products-assemblycontrol-index-en-js","26":"component---src-pages-products-index-de-js","27":"component---src-pages-products-index-en-js","28":"component---src-pages-products-logisticscontrol-index-de-js","29":"component---src-pages-products-logisticscontrol-index-en-js","30":"component---src-pages-products-metalscanner-index-de-js","31":"component---src-pages-products-metalscanner-index-en-js","32":"component---src-pages-products-paintscanner-index-de-js","33":"component---src-pages-products-paintscanner-index-en-js","34":"component---src-pages-products-surfacescanner-index-de-js","35":"component---src-pages-products-surfacescanner-index-en-js","36":"component---src-pages-products-toolbox-index-de-js","37":"component---src-pages-products-toolbox-index-en-js","38":"component---src-pages-products-weldscanner-index-de-js","39":"component---src-pages-products-weldscanner-index-en-js","40":"component---src-pages-products-woodscanner-index-de-js","41":"component---src-pages-products-woodscanner-index-en-js","42":"component---src-pages-technology-index-de-js","43":"component---src-pages-technology-index-en-js","44":"component---src-pages-terms-conditions-de-js","45":"component---src-pages-terms-conditions-en-js","46":"component---src-pages-use-cases-index-de-js","47":"component---src-pages-use-cases-index-en-js"}[chunkId]||chunkId) + "-" + {"3":"30e81bf0e77129cf7674","4":"fd94c5f6dd06f46832b2","5":"41123c73988c78e00663","6":"6af5d6ba3d8f1eafe79b","7":"7842dce7523f63bc82cc","8":"79891817f594b6413e3f","9":"4672cfc15dde0fc45974","10":"9e8c4921c63f6e9e7d1e","11":"62b67e99810e10c1aa8c","12":"597da6827de052a97c5b","13":"236a2552741183e9263d","14":"9ed6f267ea9db9adb531","15":"e7352e5286e9af00a295","16":"6c3aee0d7ebb67fc1316","17":"4b955707aaf265b02b06","18":"af65a1d85ea65834ac09","19":"083315d3764ef6ab5bd1","20":"49bc74e34230e1b7e11d","21":"4ff8202688d585453794","22":"d6bd9360548b78e0d6a9","23":"d87ec9a5171b07eec351","24":"3ef92d5fb14b65303341","25":"1afd6a044b258a5214c4","26":"eb33d634dec7843c81ad","27":"1310a8851bf8a2508d4b","28":"c57867eb4928145e8b2b","29":"19120fbde1899ea327f4","30":"07914d76147bdfd71f2d","31":"dad74d0e304750c25979","32":"7767c721666a60b77de3","33":"87cdd089886ba6876690","34":"8aeab244ed2b8d340153","35":"f88cb3571d10e775aeec","36":"fb2a1811980c421ecb85","37":"23dd08ee1f7908389486","38":"f4bae49a6c11d3059f66","39":"f70b32bebbfc4f2ee22a","40":"da1d2771fe620e8c7970","41":"0111cc7353435e62610e","42":"ec091bf883b8443c41b2","43":"4fcbca8434cf3a95db13","44":"008e84ef5c3bf9f00fbe","45":"28f4943c1aaad59d0415","46":"ad2a2a3d97e93a08a49b","47":"4c57ad839c6f8475518d"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
